import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete",
  "use": "delete-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"delete\"><defs><style></style></defs><path d=\"M512 159.437c-194.765 0-352.563 157.9-352.563 352.563S317.235 864.563 512 864.563 864.563 706.765 864.563 512 706.765 159.437 512 159.437zM756.736 512c0 16.998-13.722 30.72-30.72 30.72H297.984c-16.998 0-30.72-13.722-30.72-30.72s13.722-30.72 30.72-30.72h428.032c16.998 0 30.72 13.722 30.72 30.72z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol